import * as z from "zod";

export const ShopperAgentCooldownConfigSchema = z.object({
  cooldownHours: z.number().optional(),
});

export type ShopperAgentCooldownConfig = z.infer<
  typeof ShopperAgentCooldownConfigSchema
>;
